import React, { FC } from 'react';
import { Constants, Message } from '@wix/chat-sdk';
import { ISendersData, MessageEntry } from '@wix/chat-web';
import { connect } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { WidgetSenderIdentityType } from '../../constants/widget-sender-identity';

export interface TitleBubbleProps {
  message: Message;
  title?: string;
  widgetSenderIdentity: string;
  widgetSenderData: ISendersData;
}

const TitleBubble: FC<TitleBubbleProps> = ({
  message,
  title,
  widgetSenderIdentity,
  widgetSenderData,
}) => {
  const isSenderIdentityIncludeTitle =
    widgetSenderIdentity === WidgetSenderIdentityType.BUSINESS ||
    widgetSenderIdentity === WidgetSenderIdentityType.AGENT;
  const showTitle =
    isSenderIdentityIncludeTitle &&
    (message?.groupPosition === Constants.MessagePositionInGroup.SINGLE ||
      message?.groupPosition === Constants.MessagePositionInGroup.START);

  if (!showTitle) {
    return <div />;
  }

  const titleToPresent =
    title ??
    (widgetSenderIdentity === WidgetSenderIdentityType.BUSINESS &&
    !_isEmpty(widgetSenderData)
      ? widgetSenderData[0].userName
      : message?.senderDisplayData?.name);

  return (
    <div>
      <MessageEntry
        title={titleToPresent}
        separateTitle={true}
        groupPosition={message.groupPosition}
        position={Constants.MessageDirections.Incoming}
      />
    </div>
  );
};

function mapStateToProps(state) {
  return {
    widgetSenderIdentity: state.widgetSenderIdentity,
    widgetSenderData: state.widgetSenderData,
  };
}

export default connect(mapStateToProps)(TitleBubble);
